import React from "react";
import {connect} from "react-redux";
import {animateScroll} from "react-scroll";

import { IChatProps } from "./~types/ChatProps";
import { IMessage, IInitMessages, IButton, IFile, ILocation, ButtonContentType } from "../~store/models/messages/Message";
import { IApplicationState } from "src/~store/models/ApplicationState";
import { getIsFileImage } from "src/app/shared/helpers/file-helper/FileFormatHelper";
import { startSignalR, addMessageToState, addMessagesToState, sendFileMessage, editMessage, initializeMessages, readMessage, setFooterCopmanyTitle, sendMessage, sendPreviewUserMessage, ensureGotAllMessages, trySendStartMessage, getPrevChat } from "../~store/actions/actions";

import Typography from "@material-ui/core/Typography";
import MDEditor, { divider } from "@uiw/react-md-editor";
import Paper from "@material-ui/core/Paper";
import Card from "@material-ui/core/Card";
import Message from "./Message/Message";
import CardContent from "@material-ui/core/CardContent";
import MessageInput from "./message-input/MessageInput";
import Link from "@material-ui/core/Link";
import ShareInfoDialog, { FileType } from "../../shared/components/choose-file-dialog/ChooseFileDialog";
import { 
    messagesSelector, 
    isMessageEditingSelector, 
    firstUnreadMessageSelector,
    sendingFilesCountSelector,
    companyNameSelector,
    companyUrlSelector,
    customerIdSelector,
    sendingMessageSelector,
    isGettingPrevChatMessagesSelector,
    loadPrevChatSelector
} from "./../~store/actions/selectors";
import { useEffect, useRef, useState } from "react";
import { IChannelMessage } from 'src/app/chat/~store/models/ChannelMessage';
import VisibilitySensor from 'react-visibility-sensor';
import "./Chat.css";
import { IMessageInfo } from "../~store/models/MessageInfo";
import { HubConnectionState } from "@microsoft/signalr";
import { MessageType } from "../~store/models/messages/enums/MessageType";
import PreviewFileDialog  from "../../shared/components/preview-file-dialog/PreviewFileDialog";
import { Spinner } from "reactstrap";
import "./../../shared/components/loader/Loader.css"
import { renderToStaticMarkup } from "react-dom/server";
import SendingMessage from "./sending-message/SendingMessage";
import {isMobile} from 'react-device-detect';
import { subscribeConnectionStateChanged, unsubscribeConnectionStateChanged } from "src/~signalR/SignalRHub";
import useInterval from "src/app/shared/helpers/use-interval/UseInterval";
import useOnScreen from "src/app/shared/helpers/use-onscreen/UseOnScreen";
import { CHAT_CLOSED_TAG } from "../~store/models/Constants";
import PrevChatLoader from "./prev-chat-loader/PrevChatLoader";
import i18n from "src/app/shared/localization/i18n";

let newMessageSoundPlayer: HTMLAudioElement;

type ReduxType = ReturnType<typeof mapStateToProps> & IChatProps;

const Chat = (props: ReduxType) => {

    const [currentFileState, setCurrentFileState] = useState<{file: File | undefined, type: FileType | undefined}>({ file: undefined, type: undefined});

    const [forceButtonDisabled, setforceButtonDisabled] = useState<boolean>(false);
    const [isFirstWidgetOnScreen, setIsFirstWidgetOnScreen] = useState<boolean>(true);
    const [connectionState, setConnectionState] = useState<HubConnectionState>(props.hubConnection.state);
    const [minMessageIdInChat, setMinMessageIdInChat] = useState<number>();

    const messagesContanerRef = React.useRef<any>();

    const messageInputRef = React.useRef<MessageInput>(null)

    window.widgetOnScreen = useOnScreen(messagesContanerRef);
    
    useEffect(() => {
        props.setFooterCopmanyTitle();
        props.initializeMessages();
        subscribeConnectionStateChanged(_setConnectionState);
        newMessageSoundPlayer = new Audio(process.env.PUBLIC_URL + "/sounds/new-message-sound.mp3");
        return () => unsubscribeConnectionStateChanged(_setConnectionState);
    }, []);

    useEffect(() => {
        if(props.customerId && (props.messages.length > 0 && props.messages.find(m => m.messageId == Math.max(...props.messages.map(m2 => m2.messageId)))?.tag != CHAT_CLOSED_TAG)) {
            _startSignalR();
        }
    }, [props.customerId]);

    useEffect(() => {
        if(window.widgetOnScreen && connectionState === HubConnectionState.Connected && props.customerId) {
            props.trySendStartMessage();
        }
        else if(window.widgetOnScreen && connectionState === HubConnectionState.Disconnected) {
            _startSignalR();
        }  
    },[window.widgetOnScreen, connectionState])

    useEffect(() => {
        if (window.widgetOnScreen && isFirstWidgetOnScreen) {
            _scrollToBottom();
            setIsFirstWidgetOnScreen(false);
        }
    }, [window.widgetOnScreen]);

    useInterval(() => {
        props.ensureGotAllMessages();
    }, 5000)

    useEffect(() => {
        _scrollToBottom();
    }, [props.isMessageEditing]);

    useEffect(() => {
        if(minMessageIdInChat) {
            _scrollToMessage(minMessageIdInChat);
            setMinMessageIdInChat(undefined);
        }
        else{
            _scrollToBottom();
        }
        
        // TODO
        // setTimeout(() => {_scrollToFirstUnreadMessage();}, 500)
    }, [props.messages.length]);

    const _onSignalRMessageReceived = (message: any) => {
        const urlParams = new URLSearchParams(window.location.href);
        const isMessageSound = urlParams.get("isMessageSound") !== "false";
        switch(message.type) {
            case "NewMessage":
                props.addMessageToState(message.data);
                if((message.data as IMessage).messageType !== MessageType.ClientMessage && isMessageSound) {
                    newMessageSoundPlayer.play();
                }
                _scrollToBottom();
                break;
            /*case "InitMessages":
                props.initializeMessages(message.data);
                _scrollToBottom();
                break;*/
            case "EditMessage":
                props.editMessage(message.data);
                _scrollToBottom();
                break;
        }
    } 
    
    const _showStartMessageWithoutStartChat = (messagesCount: number) => {

        const urlParams = new URLSearchParams(window.location.href);
        const startMessageWithoutBot = urlParams.has("startMessageWithoutBot") ? urlParams.get('startMessageWithoutBot') : i18n.t("chat.askYourQuestion");
        const startMode = urlParams.get('startMode') ?? "auto";        
        const disableUsedButtons = urlParams.get('disableUsedButtons') !== "false";
        const isButtonDisabled = !disableUsedButtons ? false : messagesCount > 0;

        if(startMode === "auto")
            return React.Component;

        return <Message 
            setForceButtonDisabled={setforceButtonDisabled}
            message={{
                messageType: 1,
                timeSent: new Date(),
                text: startMessageWithoutBot,                           
                customerId: props.customerId,
                buttons: [{
                    text: "Начать"
                } as IButton],
            } as IMessage}
            isButtonsDisabled={isButtonDisabled}
            onMenuButtonClick={(button) => {
                if (!isButtonDisabled && !forceButtonDisabled) {
                    _onSendMessageHandler({text: button.text} as IMessageInfo, true);
                } else {
                    _scrollToBottom();
                }
            }}
            customerId={props.customerId}
        />
    };

    const _scrollToBottom = (): void => {
        animateScroll.scrollToBottom({
            delay: 100,
            duration: 300,
            containerId: "chat-body"
        });
    };

    const _scrollToFirstUnreadMessage = (): void => {
        // rework
        const firstUnreadMessage = props.firstUnreadMessage;
        if(firstUnreadMessage !== undefined) {
            const messageEl = document.getElementById(`message_${firstUnreadMessage.messageId}`);
            messageEl?.scrollIntoView(true);
        }
        else {
            _scrollToBottom();
        }
    }

    const _scrollToMessage = (messageId: number): void => {
        const messageEl = document.getElementById(`message_${messageId}`);
        messageEl?.scrollIntoView(true);
    }

    const _onSendMessageHandler = (messageInfo: IMessageInfo, isButtonReply: boolean = false): void => {
        props.sendMessage(messageInfo, isButtonReply);
        if(!isMobile || !isButtonReply)
            messageInputRef.current?._setFocus();
    };

    const _onInputPasteHandler = (event: any): void => {
        for (const file of event.clipboardData.files) {
          if(getIsFileImage(file.type)) {
            setCurrentFileState({...currentFileState, file, type: FileType.Image});
          }
          else {
            setCurrentFileState({...currentFileState, file, type: FileType.File});
          }
        }        
    }

    const onGetPrevChatClicked = () => {
        setMinMessageIdInChat(Math.min(...props.messages.filter(m => m.messageId != 0).map(m => m.messageId)));
        props.getPrevChat();
    }

    const _startSignalR = (): void => {
        props.startSignalR(
            _onSignalRMessageReceived);
    }

    const _setConnectionState = ():void => {
        setConnectionState(props.hubConnection.state);
    }

    const _urlHandler = (url: string): void => {
        if(url?.length > 0) 
        {
            const link = document.createElement("a");
            link.href = url;
            link.target = "_blank";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }

    const _onCustomEventButtonClicked = (button: IButton): void => {
        const urlParams = new URLSearchParams(window.location.search);
        const parentPage = urlParams.get('parent');
        if (parentPage != null) 
            window.parent.postMessage({type: "customEvent", value: button.value}, parentPage);
    }

    const _getChatControl = (): React.ReactElement<{}> => {
        const { messages } = props;
        const isSendingMessage: boolean = (props.sendingMessage && !props.sendingMessage.failed) ?? false;
        const urlParams = new URLSearchParams(window.location.href);
        const disableUsedButtons = urlParams.get('disableUsedButtons') !== "false";
        return (
            <Card className="chat__content">
                <div className="company-logo-container" >
                    <span className={"connection-status " + (connectionState === HubConnectionState.Connected ? "online" : "offline")}></span>
                    <div className="company-logo" />
                    <div className="company-title" />
                </div>
                {!props.isMessageEditing && <CardContent ref={messagesContanerRef} id="chat-body" className="chat__body">
                {props.loadPrevChat && <PrevChatLoader gettingPrevChat={props.isGettingPrevChatMessages} onGetPrevChatClicked={onGetPrevChatClicked}/>}
                    {_showStartMessageWithoutStartChat(messages.length)}

                    {messages.map((m: IMessage, index: number) => {

                        const isButtonDisabled = !disableUsedButtons ? false : messages
                            // get messages after this
                            .slice(index + 1, messages.length - 1)
                            // get only client messages
                            .filter(msg => msg.messageType === MessageType.ClientMessage)
                            // if there are no client messages - buttons enabled
                            // else - disabled
                            .length !== 0;
                        return <VisibilitySensor
                        delayedCall={true}
                        key={m.messageId}
                        containment={messagesContanerRef.current}
                        onChange={(isVisible: boolean) => {
                            if(isVisible) {
                                props.readMessage(m.messageId);
                            }
                        }}>
                            <Message
                                key={index}
                                message={m}
                                setForceButtonDisabled={setforceButtonDisabled}
                                isButtonsDisabled={isButtonDisabled}
                                onMenuButtonClick={(button) => {
                                    if (!isButtonDisabled && !forceButtonDisabled) {
                                        if (button.contentType === ButtonContentType.Link)
                                            _urlHandler(button.value);
                                        _onSendMessageHandler({text: button.text} as IMessageInfo, true);
                                        if(button.contentType === ButtonContentType.CustomEvent)
                                        {
                                            _onCustomEventButtonClicked(button);
                                        } 
                                    } else {
                                        _scrollToBottom();
                                    }                                                                    
                                }}
                                customerId={props.customerId}/>
                        </VisibilitySensor>
                    })}
                    {props.sendingMessage && <SendingMessage
                        sendingMessage={props.sendingMessage}
                        onResendClick={_onSendMessageHandler}
                    />}
                </CardContent>}
                <div className="chat__footer">
                    <div className="chat-input-contairner">
                        <div className="input-container" id="input-container">
                            <span className={"input-container__fetch-file" + (isSendingMessage ? " nonclickable" : "")}>
                                <ShareInfoDialog 
                                    onFileChoosen={(file, type) => {setCurrentFileState({...currentFileState, file, type})}}
                                    onLocationChoosen={(location) => {
                                        _onSendMessageHandler({
                                            text: "",
                                            location: {
                                                latitude: location.coords.latitude,
                                                longitude: location.coords.longitude,
                                            },
                                        })
                                    }}/>
                                <PreviewFileDialog
                                    file={currentFileState.file} 
                                    type={currentFileState.type}
                                    onFileSend={() =>{ return (currentFileState.file !== undefined && currentFileState.type !== undefined) ? 
                                    props.sendFileMessage(currentFileState.file, currentFileState.type) : 
                                    {}}}
                                />
                            </span>
                            {props.sendingFilesCount > 0 && 
                                <div className="input-container__file_loader">Sending {props.sendingFilesCount} file(s)... <Spinner style={{ width: '1rem', height: '1rem' }} />
                            </div>}
                            <span><MessageInput ref={messageInputRef}
                                onInputPasteHandler={(event) => _onInputPasteHandler(event)}
                                onSendMessage={(messageText) => _onSendMessageHandler({ text: messageText } as IMessageInfo)} 
                                onSendPreviewMessage={props.sendPreviewMessage}
                                isSendingMessage={isSendingMessage}/>
                            </span>
                            <div>
                                <Link className="chat__content-footer--link" href= {props.footerCompanyUrl} target="_blank">
                                    {props.footerCompanyName}
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </Card>
        );
    };

    return <section className="chat">{_getChatControl()}</section>;
}


const mapStateToProps = (state: IApplicationState) => {
    return {
        messages: messagesSelector(state),
        isMessageEditing: isMessageEditingSelector(state),
        isGettingPrevChatMessages: isGettingPrevChatMessagesSelector(state),
        firstUnreadMessage: firstUnreadMessageSelector(state),
        hubConnection: state.chat.hubConnection,
        sendingFilesCount: sendingFilesCountSelector(state),
        sendingMessage: sendingMessageSelector(state),
        footerCompanyName: companyNameSelector(state),
        footerCompanyUrl: companyUrlSelector(state),
        customerId: customerIdSelector(state),
        loadPrevChat: loadPrevChatSelector(state)
    };
};
const mapDispatchToProps = (dispatch: any): IChatProps => {
    return {
        startSignalR: (
            onSignalRMessageReceived: CallableFunction
        ) => dispatch(startSignalR(onSignalRMessageReceived)),
        addMessageToState: (
            message: IMessage
        ) => dispatch(addMessageToState(message)),
        getPrevChat: () => dispatch(getPrevChat()),
        sendMessage: (messageInfo: IMessageInfo, isButtonReply: boolean = false) => dispatch(sendMessage(messageInfo, isButtonReply)),
        sendPreviewMessage: (text: string) => dispatch(sendPreviewUserMessage(text)),
        sendFileMessage: (file: File, type: FileType) => dispatch(sendFileMessage(file, type)),
        editMessage: (message: IMessage) => dispatch(editMessage(message)),
        initializeMessages: () => dispatch(initializeMessages()),
        trySendStartMessage: () => dispatch(trySendStartMessage()),
        readMessage: (
            messageId: number
        ) => dispatch(readMessage(messageId)),
        setFooterCopmanyTitle: (
        ) => dispatch(setFooterCopmanyTitle()),
        ensureGotAllMessages: () => dispatch(ensureGotAllMessages())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Chat);
